import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Perfil
    {
        path: '/perfil',
        name: 'perfil',
        component: () => import('@/modules/pessoas/views/detalhes/PerfilView.vue'),
        // Sem `allowedRoles`: o próprio perfil é de qualquer usuário autenticado,
        // inclusive quem não pertence a nenhum grupo. A busca de rotas trata a
        // ausência do campo como "sem restrição".
        meta: {
            requiresAuth: true,
        },
    },
    // Edita Perfil do Usuário
    {
        path: '/perfil/editar',
        name: 'edicaoPerfil',
        component: () => import('@/modules/pessoas/views/cadastros/EdicaoPerfilView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,

        },
        props: true
    },
    // Cadastrar CNH perfil do Usuário
    {
        path: '/perfil/cadastrarcnh',
        name: 'cadastroCNH',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroCarteiraMotoristaUsuarioView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
        props: true
    },
    // Edita CNH perfil do Usuário
    {
        path: '/perfil/editar/cnh',
        name: 'edicaoCNH',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroCarteiraMotoristaUsuarioView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,

        },
        props: true
    },
    // Lista de Motoristas
    {
        path: '/motoristas',
        name: 'listaMotoristas',
        component: () => import('@/modules/pessoas/views/listas/ListaMotoristaView.vue'),
        meta: { requiresAuth: true, allowedRoles: composePermissions('ADMINISTRADOR', 'BOLSISTAPROJETO') },
    },
    // Cadastro de Motorista
    {
        path: '/cadastromotorista',
        name: 'cadastroMotorista',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroMotoristaView.vue'),
        meta: { requiresAuth: true, allowedRoles: composePermissions('ADMINISTRADOR', 'BOLSISTAPROJETO') },
    },
    // Edita Motorias
    {
        path: '/edicaomotorista/:id',
        name: 'edicaoMotorista',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroMotoristaView.vue'),
        meta: { requiresAuth: true, allowedRoles: composePermissions('ADMINISTRADOR', 'BOLSISTAPROJETO') },
        props: true
    },
    // Lista de Pessoas Físicas
    {
        path: '/pessoasfisicas',
        name: 'listaPessoaFisica',
        component: () => import('@/modules/pessoas/views/listas/ListaPessoaFisicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('GESTAO', 'RH', 'PROJETO', 'FINANCEIRO', 'COMPRAS', 'BOLSISTAPROJETO')] },
    },
    // Cadastro de Pessoa Fisica
    {
        path: '/cadastropessoafisica',
        name: 'cadastroPessoaFisica',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroPessoaFisicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('RH', 'PROJETO', 'COMPRAS', 'FINANCEIRO', 'BOLSISTAPROJETO')] },
    },
    // Edita Pessoa Fisica
    {
        path: '/edicaopessoafisica/:id',
        name: 'edicaoPessoaFisica',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroPessoaFisicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'RH', 'PROJETO', 'FINANCEIRO', 'BOLSISTAPROJETO')] },
        props: true
    },
    // Lista de Pessoas Jurídicas
    {
        path: '/pessoajuridica',
        name: 'listaPessoasJuridicas',
        component: () => import('@/modules/pessoas/views/listas/ListaPessoaJuridicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'GESTAO', 'PROJETO', 'FINANCEIRO', 'BOLSISTAPROJETO')] },
    },
    // Cadastro de Pessoa Juridica
    {
        path: '/cadastropessoajuridica',
        name: 'cadastroPessoaJuridica',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroPessoaJuridicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'PROJETO', 'BOLSISTAPROJETO', 'FINANCEIRO')] },
    },
    // Edita Pessoa Juridica
    {
        path: '/edicaopessoajuridica/:id',
        name: 'edicaoPessoaJuridica',
        component: () => import('@/modules/pessoas/views/cadastros/CadastroPessoaJuridicaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'PROJETO', 'BOLSISTAPROJETO', 'FINANCEIRO')] },
        props: true
    },
    // Lista/Busca de Projetos por Bolsista
    {
        path: '/bolsistas',
        name: 'listaBolsistas',
        component: () => import('@/modules/pessoas/views/listas/ListaBolsistaView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'GESTAO', 'PROJETO')] },
    },
    // Lista/Busca de Pagamentos por CPF/CNPJ
    {
        path: '/pagamentos-por-identificacao',
        name: 'listaPagamentosPorIdentificacao',
        component: () => import('@/modules/pessoas/views/listas/ListaPagamentosPorIdentificacaoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'GESTAO', 'PROJETO', 'FINANCEIRO')] },
    },
    // Lista de Convites
    {
        path: '/convites',
        name: 'listaConvites',
        component: () => import('@/modules/pessoas/views/listas/ListaConviteView.vue'),
        // Sem `allowedRoles`: o acesso depende de permissões do token ou de coordenar um
        // projeto, e a própria API restringe o que cada usuário vê.
        meta: { requiresAuth: true },
    },
    // Lista Usuários
    {
        path: '/usuarios',
        name: 'listaUsuarios',
        component: () => import('@/modules/pessoas/views/listas/ListaUsuarioView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES,
        },
    },
    // Reset de 2FA de Usuário
    {
        path: '/usuarios/reset2fa',
        name: 'resetDoisFatores',
        component: () => import('@/modules/pessoas/views/listas/ResetDoisFatoresView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES,
        },
    },
    // Lista de Assinaturas
    {
        path: '/assinaturas',
        name: 'listaAssinaturas',
        component: () => import('@/modules/pessoas/views/listas/ListaAssinaturaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
        redirect: { name: 'assinaturasPendentes' },
        children: [
            {
                path: '/assinaturas/pendentes',
                name: 'assinaturasPendentes',
                component: () => import('@/modules/pessoas/components/listas/ListaAssinaturasPendentes.vue'),
                meta: {
                    requiresAuth: true,
                    allowedRoles: COMMON_PERMISSIONS.TODOS,
                },
            },
            {
                path: '/assinaturas/assinados',
                name: 'assinaturasAssinados',
                component: () => import('@/modules/pessoas/components/listas/ListaAssinaturasAssinados.vue'),
                meta: {
                    requiresAuth: true,
                    allowedRoles: COMMON_PERMISSIONS.TODOS,
                },
            },
            {
                path: '/assinaturas/cancelados',
                name: 'assinaturasCancelados',
                component: () => import('@/modules/pessoas/components/listas/ListaAssinaturasCancelados.vue'),
                meta: {
                    requiresAuth: true,
                    allowedRoles: COMMON_PERMISSIONS.TODOS,
                },
            },
        ]
    },
    // Detalhe de Assinatura
    {
        path: '/assinaturas/documento/:id',
        name: 'detalheAssinatura',
        component: () => import('@/modules/pessoas/views/detalhes/DetalheAssinaturaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
        props: true,
    },
    // Meus Pagamentos
    {
        path: '/meuspagamentos',
        name: 'listaMeusPagamentos',
        component: () => import('@/modules/pessoas/views/listas/ListaMeusPagamentosPFView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
    },
    // Relatórios de Solicitação
    {
        path: '/relatoriossolicitacoes',
        name: 'listaRelatoriosSolicitacoes',
        component: () => import('@/modules/pessoas/views/listas/ListaRelatoriosSolicitacoesView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        }
    },

    // Relatórios de Viagens
    {
        path: '/passagensemitidas',
        name: 'listaPassagensEmitidas',
        component: () => import('@/modules/pessoas/views/listas/ListaPassagensEmitidasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        },
    },

    {
        path: '/relatoriossolicitacoes/detalhe/:id',
        name: 'detalheRelatorioSolicitacao',
        component: () => import('@/modules/pessoas/views/detalhes/DetalheRelatorioSolicitacaoView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.TODOS,
        }
    },

    // Lista de Contratos
    {
        path: '/listacontratos',
        name: 'listacontratos',
        component: () => import('@/modules/pessoas/views/listas/ListaContratoView.vue'),
        meta: {
            requiresAuth: true,
        },
    },
]